import { render } from "./JournalView.vue?vue&type=template&id=6a39c93a"
import script from "./JournalView.vue?vue&type=script&lang=js"
export * from "./JournalView.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/gradbeni-dnevnik/gradbeni-dnevnik/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__